import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const mergeStyle = (style?: IconProps["style"]) => ({
  color: "currentcolor",
  ...(style ?? {}),
});

export const BotIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    style={mergeStyle(style)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 2.79933C9.19835 2.53997 9.5 2.05521 9.5 1.5C9.5 0.671573 8.82843 0 8 0C7.17157 0 6.5 0.671573 6.5 1.5C6.5 2.05521 6.80165 2.53997 7.25 2.79933V5H7C4.027 5 1.55904 7.16229 1.08296 10H0V13H1V14.5V16H2.5H13.5H15V14.5V13H16V10H14.917C14.441 7.16229 11.973 5 9 5H8.75V2.79933ZM7 6.5C4.51472 6.5 2.5 8.51472 2.5 11V14.5H13.5V11C13.5 8.51472 11.4853 6.5 9 6.5H7ZM7.25 11.25C7.25 12.2165 6.4665 13 5.5 13C4.5335 13 3.75 12.2165 3.75 11.25C3.75 10.2835 4.5335 9.5 5.5 9.5C6.4665 9.5 7.25 10.2835 7.25 11.25ZM10.5 13C11.4665 13 12.25 12.2165 12.25 11.25C12.25 10.2835 11.4665 9.5 10.5 9.5C9.5335 9.5 8.75 10.2835 8.75 11.25C8.75 12.2165 9.5335 13 10.5 13Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const UserIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    data-testid="geist-icon"
    height={height}
    width={width}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    style={mergeStyle(style)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 0C5.95507 0 4.5 1.45507 4.5 3.25V3.75C4.5 5.54493 5.95507 7 7.75 7H8.25C10.0449 7 11.5 5.54493 11.5 3.75V3.25C11.5 1.45507 10.0449 0 8.25 0H7.75ZM6 3.25C6 2.2835 6.7835 1.5 7.75 1.5H8.25C9.2165 1.5 10 2.2835 10 3.25V3.75C10 4.7165 9.2165 5.5 8.25 5.5H7.75C6.7835 5.5 6 4.7165 6 3.75V3.25ZM2.5 14.5V13.1709C3.31958 11.5377 4.99308 10.5 6.82945 10.5H9.17055C11.0069 10.5 12.6804 11.5377 13.5 13.1709V14.5H2.5ZM6.82945 9C4.35483 9 2.10604 10.4388 1.06903 12.6857L1 12.8353V13V15.25V16H1.75H14.25H15V15.25V13V12.8353L14.931 12.6857C13.894 10.4388 11.6452 9 9.17055 9H6.82945Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const AttachmentIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    style={mergeStyle(style)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 6.5V13.5C14.5 14.8807 13.3807 16 12 16H4C2.61929 16 1.5 14.8807 1.5 13.5V1.5V0H3H8H9.08579C9.351 0 9.60536 0.105357 9.79289 0.292893L14.2071 4.70711C14.3946 4.89464 14.5 5.149 14.5 5.41421V6.5ZM13 6.5V13.5C13 14.0523 12.5523 14.5 12 14.5H4C3.44772 14.5 3 14.0523 3 13.5V1.5H8V5V6.5H9.5H13ZM9.5 2.12132V5H12.3787L9.5 2.12132Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const VercelIcon = ({
  className,
  style,
  height = 17,
  width = 17,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    style={mergeStyle(style)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1L16 15H0L8 1Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const SearchIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={mergeStyle(style)}
    {...props}
  >
    <rect fill="none" height="24" width="24" />
    <rect height="2" width="15" x="2" y="4" fill="currentColor" />
    <path
      d="M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3zm-6 1H4v-4h5v4zm-5.96-6 .6-3h11.72l.6 3H3.04z"
      fill="currentColor"
    />
    <polygon
      points="23,18 20,18 20,15 18,15 18,18 15,18 15,20 18,20 18,23 20,23 20,20 23,20"
      fill="currentColor"
    />
  </svg>
);

export const StoriesIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 -960 960 960"
    style={mergeStyle(style)}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M680-160v-640q33 0 56.5 23.5T760-720v480q0 33-23.5 56.5T680-160ZM160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h360q33 0 56.5 23.5T600-800v640q0 33-23.5 56.5T520-80H160Zm680-160v-480q25 0 42.5 17.5T900-660v360q0 25-17.5 42.5T840-240Zm-680 80h360v-640H160v640Zm0-640v640-640Z"
      fill="currentColor"
    />
  </svg>
);

export const SideNavigationIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  strokeLinejoin = "round",
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    strokeLinejoin={strokeLinejoin}
    viewBox="0 0 24 24"
    style={mergeStyle(style)}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="none" height="24" width="24" />
    <rect x="4" y="6" width="16" height="2" fill="currentColor" />
    <rect x="4" y="11" width="16" height="2" fill="currentColor" />
    <rect x="4" y="16" width="16" height="2" fill="currentColor" />
  </svg>
);

export const MobileSidebarIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  strokeLinejoin = "round",
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    strokeLinejoin={strokeLinejoin}
    viewBox="0 0 24 24"
    style={mergeStyle(style)}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="none" height="24" width="24" />
    <rect x="6" y="8" width="12" height="2" fill="currentColor" />
    <rect x="8" y="13" width="8" height="2" fill="currentColor" />
  </svg>
);

export const ChatIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  strokeWidth = 2,
  strokeLinecap = "round",
  strokeLinejoin = "round",
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
    style={mergeStyle(style)}
    {...props}
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

export const PortfolioIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 -960 960 960"
    xmlns="http://www.w3.org/2000/svg"
    style={mergeStyle(style)}
    {...props}
  >
    <path
      d="M200-200v-560 179-19 400Zm80-240h221q2-22 10-42t20-38H280v80Zm0 160h157q17-20 39-32.5t46-20.5q-4-6-7-13t-5-14H280v80Zm0-320h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v258q-14-26-34-46t-46-33v-179H200v560h202q-1 6-1.5 12t-.5 12v56H200Zm480-200q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM480-120v-56q0-24 12.5-44.5T528-250q36-15 74.5-22.5T680-280q39 0 77.5 7.5T832-250q23 9 35.5 29.5T880-176v56H480Z"
      fill="currentColor"
    />
  </svg>
);


export const BarChartIcon = ({
  className,
  style,
  height = 16,
  width = 16,
  ...props
}: IconProps) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={mergeStyle(style)}
    {...props}
  >
    <rect x="4" y="11" width="3" height="9" fill="currentColor" />
    <rect x="10.5" y="5" width="3" height="15" fill="currentColor" />
    <rect x="17" y="8" width="3" height="12" fill="currentColor" />
  </svg>
);


export const StopIcon = ({
  className,
  style,
  height = 5,
  width = 5,
  ...props}: IconProps) => (
  <svg className={className} height={height} width={width} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={mergeStyle(style)} {...props}>
    <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor"/>
  </svg>
);


export const DesktopSideNavigationIcon = () => {
  return (
    <svg
      height="16"
      width="16"
      strokeLinejoin="round"
      viewBox="0 -960 960 960"
      style={{ color: "currentcolor" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm280-80h280v-560H480v560Z"
        fill="currentColor"
      />
    </svg>
  );
};